import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/WeatherForecast.css';

const WeatherForecast = ({ onClose }) => {
  const [selectedVillage, setSelectedVillage] = useState('');
  const [forecast, setForecast] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const API_KEY = process.env.REACT_APP_WEATHER_KEY;

  const handleVillageChange = (event) => {
    const searchValue = event.target.value;
    setSelectedVillage(searchValue);
    const filteredResults = searchValue
      ? forecast.filter((day) => day.village && day.village.toLowerCase().includes(searchValue.toLowerCase()))
      : forecast;
    setSearchResults(filteredResults);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchWeatherForecast = async () => {
      try {
        const response = await axios.get(
          `https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/${selectedVillage}?key=${API_KEY}&unitGroup=metric&lang=el`
        );
        setForecast(response.data.days);
        setSearchResults(response.data.days);
      } catch (error) {
        console.error(error);
      }
    };

    if (selectedVillage) {
      fetchWeatherForecast();
    }
  }, [selectedVillage]);

  return (
    <div className="parent-container">
      <div className="popup">
        <div className="popup-content">
          <h1>Επιλογή Περιοχής</h1>
          {/* <input
            type="text"
            placeholder="Αναζήτηση..."
            onChange={handleVillageChange}
            value={selectedVillage}
            className="search-input"
          /> */}
          <select value={selectedVillage} onChange={handleVillageChange}>
            <option value="">Περιοχή</option>
            <option value="Αίγιο,GR">Αίγιο</option>
            <option value="Αμαλιάδα,GR">Αμαλιάδα</option>
            <option value="Άργος,GR">Άργος</option>
            <option value="Βουνό,GR">Βουνό</option>
            <option value="Καλαμάτα,GR">Καλαμάτα</option>
            <option value="Καμάρι Κορινθίας,GR">Καμάρι</option>
            <option value="Κάψια,GR">Κάψια</option>
            <option value="Κόρινθος,GR">Κόρινθος</option>
            <option value="Λουκά,GR">Λουκά</option>
            <option value="Μαντίνεια,GR">Μαντίνεια</option>
            <option value="Μανθυρέα,GR">Μανθυρέα</option>
            <option value="Ναύπλιο,GR">Ναύπλιο</option>
            <option value="Νεμέα,GR">Νεμέα</option>
            <option value="Πάτρα,GR">Πάτρα</option>
            <option value="Παλλάντιο,GR">Παλλάντιο</option>
            <option value="Πύργος,GR">Πύργος</option>
            <option value="Σπάρτη,GR">Σπάρτη</option>
            <option value="Τεγέα,GR">Τεγέα</option>
            <option value="Τρίπολη,GR">Τρίπολη</option>
            <option value="Ζευγολατιό,GR">Ζευγολατιό</option>
            <option value="Φιλιατρά,GR">Φιλιατρά</option>
          </select>

          {selectedVillage && (
            <div>
              <h1>15-ήμερη Πρόβλεψη Καιρού {selectedVillage}</h1>
              {searchResults.length > 0 ? (
                <table className="weather-table">
                  <thead>
                    <tr>
                      <th>Ημερομηνία</th>
                      <th>Θερμοκρασία</th>
                      <th>Καιρικές Συνθήκες</th>
                      <th>Υγρασία</th>
                      <th>Δείκτης UV</th>
                      <th>Ηλιακή Ακτινοβολία</th>
                      <th>Ταχύτητα Ανέμου</th>
                      <th>Ανατολή Ηλίου</th>
                      <th>Δύση Ηλίου</th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchResults.map((day) => (
                      <tr key={day.datetime}>
                        <td>{formatDate(day.datetime)}</td>
                        <td>{` ${day.tempmin}°C-${day.tempmax}°C`}</td>
                        <td>{day.conditions}</td>
                        <td>{day.humidity}%</td>
                        <td>{day.uvindex}</td>
                        <td>{day.solarradiation}</td>
                        <td>{day.windspeed}km/h</td>
                        <td>{day.sunrise}</td>
                        <td>{day.sunset}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Δεν βρέθηκαν αποτελέσματα.</p>
              )}
            </div>
          )}

          <button className="close-button" onClick={onClose}>
            Κλείσιμο
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeatherForecast;
